<div class="community-channel-dailog p-30" *ngIf="!data.isPoll" [ngStyle]="{
       'background-color':settingsData?.space_bg_primary_color,
       'color':settingsData?.space_font_primary_color
     }">

  <!-- Title -->
  <div class="fs-22 fw-600 w-100 mb-20 text-center dynamic-font"
    [ngStyle]="{ 'font-size':settingsData?.form_fs_main_title, 'color':settingsData?.space_font_primary_color}">
    {{ data.isAddChannel ? 'Create Space' : (data.isReportUser ? 'Report User' : 'Report Channel') }}
  </div>

  <!-- Subheading -->
  <div class="fs-18 fw-500 w-100 mb-20 text-center dynamic-font" *ngIf="data.isReportUser || data.isReportChannel"
    [ngStyle]="{ 'font-size':settingsData?.form_fs_sub_title,'color':settingsData?.space_font_primary_color }">
    Please provide the following details
  </div>

  <!-- Form -->
  <div class="mb-20 mt-30">
    <form [formGroup]="communityForm" autocomplete="off" fxFlex="100%" fxLayout="row wrap" fxLayoutGap="15px grid"
      class="tab-form">

      <!-- Create Channel Mode -->
      <ng-container *ngIf="data.isAddChannel">
        <div fxFlex="100%" class="pb-5 mr-0">
          <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.space_font_primary_color">
            <mat-label [ngStyle]="{'color':settingsData?.space_font_primary_color}" class="dynamic-font">Space Name</mat-label>
            <input matInput formControlName="channel_name" [style.color]="settingsData?.space_font_primary_color + ' !important'" class="dynamic-font"/>
            <mat-error *ngIf="communityForm.get('channel_name')?.hasError('required')" class="dynamic-font">
              Please enter space name
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="100%" class="pb-5 mr-0">
          <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.space_font_primary_color">
            <mat-label [ngStyle]="{'color':settingsData?.space_font_primary_color}" class="dynamic-font">Description</mat-label>
            <input matInput formControlName="description" [style.color]="settingsData?.space_font_primary_color + ' !important'" class="dynamic-font"/>
            <mat-error *ngIf="communityForm.get('description')?.hasError('required')" class="dynamic-font">
              Please enter description
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Report User Mode -->
      <ng-container *ngIf="data.isReportUser || data.isReportChannel">
        <div fxFlex="100%" fxFlex.xs="100%">
          <mat-radio-group class="d-flex flex-col" formControlName="reason" required [style.--radio-border-color]="settingsData?.space_button_secondary_color">
            <mat-radio-button *ngFor="let reason of ['harassment', 'danger', 'abuse', 'terrorism', 'spam', 'rights']"
              [value]="reason" class="pr-25 circle pb-10 custom-radio dynamic-font"  [ngStyle]="{
                '--radio-color': settingsData?.space_button_font_secondary_color || '#3f51b5',
                '--radio-label': settingsData?.space_font_primary_color || '#3f51b5',
              }">
              <span class="dynamic-font">{{ reason | titlecase }}</span>
            </mat-radio-button>
            <mat-error class="pl-13 pt-5" *ngIf="communityForm.get('reason')?.hasError('required')" class="dynamic-font">
              Please select a reason
            </mat-error>
          </mat-radio-group>
        </div>

        <div fxFlex="100%" class="pb-5 mr-0" *ngIf="communityForm.get('reason')?.value">
          <div class="w-100">
            <mat-label [ngStyle]="{'color':settingsData?.space_font_primary_color}" class="dynamic-font">Description*</mat-label>
            <textarea matInput formControlName="description" required class="w-100 mt-10 desc-text p-5 dynamic-font" [ngStyle]="{
                        'background-color':settingsData?.space_font_primary_color,
                        'color':settingsData?.space_bg_primary_color,
                        'font-size':settingsData?.fs_sentence
                      }"></textarea>
            <mat-error *ngIf="communityForm.get('description')?.hasError('required')" class="dynamic-font">
              Please enter description
            </mat-error>
          </div>
        </div>
      </ng-container>
    </form>
  </div>

  <!-- Footer Buttons -->
  <div class="text-center" [ngStyle]="{'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}"> 
    <button mat-flat-button class="flat-primary-button button-7 mt-20 mr-15" (click)="closeDialog(false,{condition: (data.isReportChannel || data.isReportUser)})"
     [ngStyle]="{
              'background-color':settingsData?.space_button_primary_color ,
              'color':settingsData?.space_button_font_primary_color,'font-family': settingsData?.font_family}">
      Cancel
    </button>

    <button mat-button class="flat-primary-button button-1 mt-20 save dynamic-font" (click)="closeDialog(true,{condition: (data.isReportChannel || data.isReportUser)})" [ngStyle]="{
              'background-color': settingsData?.space_button_secondary_color ? settingsData?.space_button_secondary_color : settingsData?.main_bg_color,
              'color':settingsData?.space_button_font_secondary_color,
              'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}"
              [disabled]="!userInfo?.id" >
      {{ data.isReportUser || data.isReportChannel ? 'Report' : 'Save' }}
    </button>
  </div>
</div>

<!-- Poll Form -->
<div class="community-channel-dailog p-30" *ngIf="data.isPoll" [ngStyle]="{
  'background-color':settingsData?.space_bg_primary_color,
  'color':settingsData?.settingsData?.space_font_primary_color,
  'font-family':settingsData?.font_family
}">
  <div class="fs-22 fw-600 w-100 mb-20 text-center dynamic-font"
    [ngStyle]="{ 'font-size':settingsData?.form_fs_main_title, 'color':settingsData?.space_font_primary_color}">
    Create Poll
  </div>

  <form [formGroup]="pollForm">
    <mat-form-field appearance="fill" class="w-100" [style.--form-border-color]="settingsData?.space_font_primary_color">
      <mat-label [ngStyle]="{'color':settingsData?.space_font_primary_color}" class="dynamic-font">Question</mat-label>
      <input  [style.color]="settingsData?.space_font_primary_color + ' !important'"  matInput formControlName="question" required class="dynamic-font"/>
    </mat-form-field>

    <div formArrayName="options">
      <div *ngFor="let option of options.controls; let i = index" class="mb-10">
        <mat-form-field appearance="fill" class="w-100"  [style.--form-border-color]="settingsData?.space_font_primary_color">
          <input matInput [formControlName]="i"  placeholder="Option {{ i + 1 }}" [style.color]="settingsData?.space_font_primary_color + ' !important'"/>
          <button mat-icon-button matSuffix (click)="removeOption(i)" *ngIf="options.controls.length > 2">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
 
    <div class="mb-20 pointer text-accent dynamic-font" (click)="addOption()" [ngStyle]="{'color':settingsData?.space_font_primary_color}">+ Add option</div>

    <mat-slide-toggle  formControlName="allowMultiple"><span [ngStyle]="{'color':settingsData?.space_font_primary_color}" class="dynamic-font">Allow multiple answers</span></mat-slide-toggle>

    <div class="text-center" [ngStyle]="{'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}">
      <button mat-flat-button class="flat-primary-button button-7 mt-20 mr-15 dynamic-font" (click)="closeDialog(false)" [ngStyle]="{
                'background-color':settingsData?.space_button_primary_color,
                'color':settingsData?.space_button_font_primary_color}">
        Cancel
      </button>

      <button mat-button class="flat-primary-button button-1 mt-20 save dynamic-font" (click)="createPoll()" [ngStyle]="{
                'background-color': settingsData?.space_button_secondary_color ? settingsData?.space_button_secondary_color : settingsData?.main_bg_color,
                'color':settingsData?.space_button_font_secondary_color,
                'cursor': userInfo?.id ? 'pointer' : 'not-allowed'}"
                 [disabled]="!userInfo?.id">
        Create Poll
      </button>
    </div>
  </form>
</div>